import { useMMGRSettings } from '../../../utils/hoc/withMMGRSettings';
import { useBoolean } from '../../../utils/hooks/useBoolean';
import { useEffect } from 'react';

export const useIsAddMediaButtonVisible = () => {
  const { mmgrSettings } = useMMGRSettings();

  const { value: isAddMediaButtonVisible, set: setAddMediaButtonVisible } = useBoolean(
    mmgrSettings.addMediaButtonVisible,
  );

  useEffect(() => {
    setAddMediaButtonVisible(mmgrSettings.addMediaButtonVisible);
  }, [mmgrSettings.addMediaButtonVisible]);

  return {
    isAddMediaButtonVisible,
  };
};
